import { combineReducers } from 'redux';

import auth from './auth';
import userManagement from './userManagement';

import global from './global';
import dashboard from './dashboard';
import settings from './settings';
import customer from './customer';
import ticketOut from './ticketOut';
import alerts from './alerts';
import account from './account';
import loan from './loan';
import audit from './audit';
import employeeSessionV2 from './employeeSessionV2';
import boost from './boost';
import onboarding from './onboarding';
import accessRequests from './accessRequests';
import planCatalog from './planCatalog';

const rootReducer = combineReducers({
  auth,
  userManagement,
  global,
  dashboard,
  customer,
  settings,
  ticketOut,
  alerts,
  account,
  loan,
  audit,
  employeeSessionV2,
  boost,
  onboarding,
  accessRequests,
  planCatalog,
});

export default rootReducer;
